import { Container, Text, TextStyle } from 'pixi.js';

export class ScorePopup extends Container {
  private text: Text;
  private duration = 1.0;
  private timer = 0;
  private initialY: number;
  private riseDistance = 60;

  constructor(x: number, y: number, points: number) {
    super();

    const style = new TextStyle({
      fontFamily: 'Rubik, Arial, sans-serif',
      fontSize: 32,
      fontWeight: 'bold',
      fill: '#FFD700',
      stroke: { color: '#000000', width: 3 },
      align: 'center',
    });

    this.text = new Text({
      text: `+${points}`,
      style,
    });

    this.text.anchor.set(0.5, 0.5);

    this.x = x;
    this.y = y;
    this.initialY = y;

    this.addChild(this.text);
  }

  update(deltaTime: number): void {
    this.timer += deltaTime;
    const progress = Math.min(this.timer / this.duration, 1);

    // Rise up
    this.y = this.initialY - this.riseDistance * progress;

    // Fade out
    this.alpha = 1 - progress;

    // Scale slightly
    const scale = 1 + 0.2 * Math.sin(progress * Math.PI);
    this.text.scale.set(scale);
  }

  isComplete(): boolean {
    return this.timer >= this.duration;
  }
}
